import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SharedModule } from '@Shared/shared.module';


@Component({
    selector: 'json-viewer',
    templateUrl: './json-viewer.component.html',
    styleUrls: ['./json-viewer.component.scss'],
    imports: [SharedModule]
})
export default class JsonViewer implements OnChanges {
    @Input() src: string;

    contents = '';

    loadContents() {
        fetch(this.src).then(value => value.json()).then(txt => this.contents = txt);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.src.currentValue)
            this.loadContents();
    }
}
